import { Location as RouterLocation, useLocation, useNavigate } from "react-router-dom"
import Modal from "../../../components/Modal"
import { CinemaPicker } from "../../../features/location"
import { appStore } from "../../../store/appStore"
import { cinemaHref, slugForCinemaId, stripCinemaSlug } from "../../../lib/cinemaSlugs"

type LocationModalState = {
    returnTo?: string
    backgroundLocation?: RouterLocation
}

export default function Location() {
    const navigate = useNavigate()
    const location = useLocation()
    const state = location.state as LocationModalState | null

    const handleApplied = () => {
        const cinema = appStore.getState().cinema
        const slug = slugForCinemaId(cinema.id)
        const fromPath = state?.returnTo?.split("?")[0] || state?.backgroundLocation?.pathname
        const rest = fromPath ? stripCinemaSlug(fromPath) : "/afisha"
        const cinemaScoped =
            rest === "/afisha" ||
            rest.startsWith("/afisha/") ||
            rest === "/contacts" ||
            /^\/promo\/[^/]+$/.test(rest)

        if (slug && cinemaScoped) {
            const dest = rest.startsWith("/afisha/film/") || /^\/promo\/[^/]+$/.test(rest) || rest === "/" ? "/afisha" : rest
            navigate(cinemaHref(slug, dest), { replace: true })
            return
        }

        if (state?.returnTo) {
            navigate(state.returnTo, {
                replace: true,
                state: state.backgroundLocation?.state ?? undefined,
            })
            return
        }
        navigate(-1)
    }

    return (
        <Modal sheet>
            <div className="flex min-h-0 w-full flex-1 flex-col overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch] px-4 sm:px-8 pb-[max(1.5rem,var(--safe-bottom))] pt-2 sm:pb-10">
                <CinemaPicker variant="modal" onApplied={handleApplied} />
            </div>
        </Modal>
    )
}
